import { render, staticRenderFns } from "./boardselect.vue.html?vue&type=template&id=1becd8e6"
import script from "./boardselect.controller?vue&type=script&lang=js&external"
export * from "./boardselect.controller?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports